/* Bakeware Kits (Oct 23 2026, v2): hub filters + "What are you baking?" chooser; kit size (Essentials/Complete), price level
   (Budget/Our pick/Premium), "I have this" ticks saved on this device, and the Amazon add-to-cart link (Associates form: the
   shopper signs in and confirms on Amazon). Totals only from Creators API prices under 24 hours old. No tracking events. */
(function () {
  var store = {
    get: function (k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---- hub ---- */
  var hub = document.querySelector('[data-bk-hub]');
  if (hub) {
    var chips = hub.querySelectorAll('[data-bk-g]'), cards = hub.querySelectorAll('[data-bk-card]');
    var setG = function (g) {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-bk-g') === g)); });
      cards.forEach(function (c) { c.hidden = !!g && (' ' + c.getAttribute('data-g') + ' ').indexOf(' ' + g + ' ') < 0; });
    };
    chips.forEach(function (c) { c.addEventListener('click', function () { setG(c.getAttribute('data-bk-g')); }); });
    var h = (location.hash || '').replace('#', '');
    if (h && hub.querySelector('[data-bk-g="' + h + '"]')) setG(h);
    var wch = hub.querySelectorAll('[data-bk-w]'), gcards = hub.querySelectorAll('[data-bk-gcard]');
    wch.forEach(function (c) {
      c.addEventListener('click', function () {
        var w = c.getAttribute('data-bk-w');
        wch.forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); });
        gcards.forEach(function (g) { g.hidden = !!w && (' ' + g.getAttribute('data-w') + ' ').indexOf(' ' + w + ' ') < 0; });
      });
    });
    var form = hub.querySelector('[data-bk-chooser]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var kit = form.querySelector('[name="kit"]').value, lvl = (form.querySelector('[name="lvl"]:checked') || {}).value || 'new';
      if (!kit) { form.querySelector('[name="kit"]').focus(); return; }
      var q = { 'new': 'size=E&tier=S', 'some': 'size=C&tier=S', 'pro': 'size=C&tier=P' }[lvl];
      location.href = kit + '?' + q;
    });
  }

  /* ---- kit page ---- */
  var kit = document.querySelector('[data-bk-kit]');
  if (!kit) return;
  var KEY = 'vg_kits_owned_v1';
  var owned = store.get(KEY) || {};
  var tag = kit.getAttribute('data-tag');
  var params = new URLSearchParams(location.search);
  var size = params.get('size') === 'C' ? 'C' : 'E';
  var tier = /^[BSP]$/.test(params.get('tier') || '') ? params.get('tier') : (store.get('vg_kits_tier_v1') || 'S');
  if (!kit.querySelector('[data-bk-tier]')) tier = 'S';
  var items = kit.querySelectorAll('.bk-item'), groups = kit.querySelectorAll('[data-bk-group]');
  var carts = kit.querySelectorAll('[data-bk-cart]'), ns = kit.querySelectorAll('[data-bk-n]');
  var left = kit.querySelector('[data-bk-left]'), total = kit.querySelector('[data-bk-total]');
  var prices = null, pEl = kit.querySelector('[data-bk-prices]');
  if (pEl) { try { prices = JSON.parse(pEl.textContent); } catch (e) {} }
  var fresh = prices && prices.fetched_at && (Date.now() - Date.parse(prices.fetched_at)) < 24 * 3600 * 1000;

  items.forEach(function (li) {
    var s = li.getAttribute('data-slot'), box = li.querySelector('[data-bk-own]');
    if (s && box && !box.hasAttribute('data-bk-up') && owned[s]) box.checked = true;
  });

  var update = function () {
    var asins = [], sum = 0, priced = 0, amz = 0;
    items.forEach(function (li) {
      var t = li.getAttribute('data-t');
      li.hidden = (t === 'C' && size === 'E');
      li.querySelectorAll('[data-v]').forEach(function (v) { v.hidden = v.getAttribute('data-v') !== tier; });
      var box = li.querySelector('[data-bk-own]');
      if (!box || li.hidden) return;
      amz++;
      var up = box.hasAttribute('data-bk-up');
      li.classList.toggle('is-owned', !up && box.checked);
      var on = up ? box.checked : !box.checked;
      var v = li.querySelector('[data-v="' + tier + '"]');
      if (on && v) {
        var a = v.getAttribute('data-asin');
        asins.push(a);
        if (fresh && prices.items && prices.items[a] != null) { sum += prices.items[a]; priced++; }
      }
    });
    groups.forEach(function (g) { g.hidden = !g.querySelector('.bk-item:not([hidden])'); });
    var u = 'https://www.amazon.com/gp/aws/cart/add.html?AssociateTag=' + encodeURIComponent(tag);
    asins.forEach(function (a, i) { u += '&ASIN.' + (i + 1) + '=' + a + '&Quantity.' + (i + 1) + '=1'; });
    carts.forEach(function (c) {
      c.href = u;
      c.classList.toggle('is-off', asins.length === 0);
      c.setAttribute('aria-disabled', String(asins.length === 0));
    });
    ns.forEach(function (n) { n.textContent = asins.length; });
    carts.forEach(function (c) { c.hidden = amz === 0; });
    if (left) left.textContent = amz === 0 ? 'Everything in this list comes from VanillaGoods.' : asins.length === 0 ? 'You have everything in this list.' :
      asins.length + ' Amazon item' + (asins.length === 1 ? '' : 's') + ' left after the ones you own. You confirm every item on Amazon.';
    if (total) {
      if (fresh && priced === asins.length && asins.length > 0) {
        var when = new Date(prices.fetched_at);
        total.textContent = 'About $' + sum.toFixed(2) + ' on Amazon for these ' + asins.length + ' items, as of ' +
          when.toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) +
          '. Product prices and availability are accurate as of the date/time indicated and are subject to change.';
        total.hidden = false;
      } else { total.hidden = true; }
    }
  };

  var seg = function (attr, val) {
    kit.querySelectorAll('[' + attr + ']').forEach(function (b) { b.setAttribute('aria-checked', String(b.getAttribute(attr) === val)); });
  };
  kit.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bk-size],[data-bk-tier]');
    if (b) {
      if (b.hasAttribute('data-bk-size')) { size = b.getAttribute('data-bk-size'); seg('data-bk-size', size); }
      else { tier = b.getAttribute('data-bk-tier'); seg('data-bk-tier', tier); store.set('vg_kits_tier_v1', tier); }
      update();
      return;
    }
    var vg = e.target.closest('[data-bk-vg]');
    if (vg) {
      var ids = vg.getAttribute('data-bk-vg').split(',').filter(Boolean), msg = kit.querySelector('[data-bk-vg-msg]');
      vg.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: +id, quantity: 1 }; }) }) })
        .then(function (r) { if (!r.ok) throw r; if (msg) msg.innerHTML = 'Added. <a href="/cart">View your bag</a>'; })
        .catch(function () { if (msg) msg.textContent = 'Could not add it right now. Please try the product link instead.'; })
        .then(function () { vg.disabled = false; });
      return;
    }
    var c = e.target.closest('[data-bk-cart]');
    if (c && c.classList.contains('is-off')) e.preventDefault();
  });
  kit.addEventListener('change', function (e) {
    var box = e.target;
    if (!box.hasAttribute('data-bk-own')) return;
    var li = box.closest('.bk-item'), s = li && li.getAttribute('data-slot');
    if (s && !box.hasAttribute('data-bk-up')) { if (box.checked) owned[s] = 1; else delete owned[s]; store.set(KEY, owned); }
    update();
  });
  seg('data-bk-size', size);
  seg('data-bk-tier', tier);
  update();
})();
